(function () {
  'use strict';

  function swapMainImage(src, alt) {
    if (!src) return;
    var mainImg = document.querySelector('[data-pdp-main-img]');
    if (mainImg) {
      mainImg.style.opacity = '0';
      mainImg.style.transform = 'scale(0.97)';
      setTimeout(function () {
        mainImg.src = src;
        if (alt) mainImg.alt = alt;
        mainImg.style.opacity = '1';
        mainImg.style.transform = 'scale(1)';
      }, 160);
      return;
    }

    var productImg = document.querySelector('.product_variant_image, .product__media img, #ProductPhotoImg');
    if (productImg) {
      productImg.src = src;
      if (alt) productImg.alt = alt;
    }
  }

  function syncThumbActive(src) {
    if (!src) return;
    var thumbs = document.querySelectorAll('[data-pdp-thumb]');
    if (!thumbs.length) return;
    var matched = false;
    thumbs.forEach(function (thumb) {
      var isMatch = thumb.dataset.fullSrc === src;
      thumb.classList.toggle('is-active', isMatch);
      if (isMatch) matched = true;
    });
    if (!matched && thumbs[0]) {
      thumbs[0].classList.add('is-active');
    }
  }

  function initVariantPicker() {
    document.querySelectorAll('[data-eride-variant-picker]').forEach(function (picker) {
      if (picker.dataset.bound) return;
      picker.dataset.bound = 'true';

      var form = picker.closest('form');
      var nativeSelect = picker.querySelector('.eride-variant-picker__native');
      var buttons = picker.querySelectorAll('.eride-variant-picker__btn');

      function applyVariant(btn) {
        if (!btn || btn.disabled) return;
        var variantId = btn.dataset.variantId;
        var imageSrc = btn.dataset.variantImage;
        var label = btn.querySelector('.eride-variant-picker__text');
        var alt = label ? label.textContent.trim() : '';

        buttons.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        if (nativeSelect) {
          nativeSelect.value = variantId;
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (form) {
          var hiddenId = form.querySelector('input[name="id"]:not(.eride-variant-picker__native)');
          if (hiddenId && hiddenId !== nativeSelect) hiddenId.value = variantId;
        }

        var productSelect = document.getElementById('productSelect');
        if (productSelect && productSelect !== nativeSelect) {
          productSelect.value = variantId;
          if (typeof jQuery !== 'undefined') {
            jQuery(productSelect).trigger('change');
          } else {
            productSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        swapMainImage(imageSrc, alt);
        syncThumbActive(imageSrc);
        document.dispatchEvent(new CustomEvent('eride:variant-change', {
          detail: { variantId: parseInt(variantId, 10), image: imageSrc, label: alt }
        }));
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          applyVariant(btn);
        });
      });
    });
  }

  function initPdpGallery() {
    var pdp = document.querySelector('[data-eride-pdp]');
    if (!pdp) return;

    var mainImg = pdp.querySelector('[data-pdp-main-img]');
    var thumbs = pdp.querySelectorAll('[data-pdp-thumb]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.fullSrc;
        if (!src) return;
        mainImg.style.opacity = '0';
        mainImg.style.transform = 'scale(0.97)';
        setTimeout(function () {
          mainImg.src = src;
          mainImg.style.opacity = '1';
          mainImg.style.transform = 'scale(1)';
        }, 180);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  function initPdpAtc() {
    var btn = document.querySelector('[data-eride-pdp-atc]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (typeof Shopify !== 'undefined' && Shopify.addItemFromFormStart) {
        Shopify.addItemFromFormStart('ErideVehicleForm', btn.dataset.productId);
      } else {
        document.getElementById('ErideVehicleForm').submit();
      }
    });
  }

  function initPdpSticky() {
    var pdp = document.querySelector('[data-eride-pdp]');
    var sticky = document.getElementById('eride-pdp-sticky');
    var stickyBtn = document.querySelector('[data-eride-sticky-atc]');
    var mainAtc = document.querySelector('[data-eride-pdp-atc]');
    if (!pdp || !sticky) return;

    if (stickyBtn && mainAtc) {
      stickyBtn.addEventListener('click', function () { mainAtc.click(); });
    }

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sticky.classList.toggle('is-visible', !e.isIntersecting);
          sticky.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
        });
      }, { threshold: 0, rootMargin: '0px' });
      obs.observe(pdp.querySelector('.eride-pdp__atc') || pdp);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVariantPicker();
      initPdpGallery();
      initPdpAtc();
      initPdpSticky();
    });
  } else {
    initVariantPicker();
    initPdpGallery();
    initPdpAtc();
    initPdpSticky();
  }
})();
